// extracted by mini-css-extract-plugin
export var root = "oWMn";
export var rootHasChildren = "G-cc";
export var rootIcon = "ejDH";
export var rootImage = "MecF";
export var rootName = "rKXE";
export var rootPicture = "NKCC";
export var rootTitle = "cQxo";
export var rootVerified = "_5IG-";
export var rootVerifiedIcon = "_1VB4";